<template>
  <div class="wrapper bg">
    <div class="main-content-wrap">
      <div class="main-content-pannel">
        <div class="form">
          <h3 class="title">Enter your project here:</h3>
          <div class="form-title">Title</div>
          <div class="flex section">
            <div class="flex-1">
              <div class="form-inline">
                <input
                  type="text"
                  placeholder="Describe the project/role you are looking to fill"
                  v-model="title"
                />
              </div>
            </div>
            <div class="tips">
              <p>Here are some good examples:</p>
              <p>-Helpdesk engineer for Mac/PC environment</p>
              <p>-VOip engineer for 6 month project</p>
              <p>-Okta installation engineer</p>
            </div>
          </div>

          <div class="form-title">Responsibilities</div>
          <div class="flex section">
            <div class="flex-1">
              <div class="form-inline">
                <quill-editor
                  name="responsibilities"
                  :options="editorOption"
                  v-model="task"
                />
              </div>
              <div class="file-wrapper">
                <button class="btn m-t">Upload Project Files</button>
                <input
                  class="file-input"
                  type="file"
                  @change="onChange"
                  multiple
                />
              </div>
              <div class="file-name-wrapper">
                <div v-for="(item, index) in files" :key="index">
                  {{ item.name }}
                </div>
              </div>
            </div>
            <div class="tips">
              <p>A good description includes:</p>
              <p></p>
              <p>What the deliverable is</p>
              <p>What the task is</p>
            </div>
          </div>

          <div class="form-title">IT Skill Requirements</div>
          <div class="flex section">
            <div class="flex-1">
              <div class="form-inline">
                <quill-editor
                  name="responsibilities"
                  :options="editorOption"
                  v-model="skills"
                />
              </div>
            </div>
            <div class="tips">
              <p>List of skills required for the role:</p>
              <p>Example:</p>
              <p>2 years of mac helpdesk support experience</p>
              <p>1 year of active directory experience</p>
            </div>
          </div>

          <!-- <div class="form-title">Details</div> -->
          <!-- <div class="flex section section2">
            <div class="flex-1">
              <div class="form-inline flex-row">
                <label for="">Budget Per Hour:</label>
                <div>
                  <input
                    type="text"
                    placeholder="The hourly rate for the tech you are looking for"
                    v-model="rate_per_hour"
                  />
                </div>
              </div>

              <div class="form-inline flex-row">
                <label for="">Location:</label>
                <div>
                  <input
                    type="text"
                    placeholder="Where do you want the tech to work at"
                    v-model="location"
                  />
                </div>
              </div>

              <div class="form-inline flex-row">
                <label for="">Start date:</label>
                <div class="form-inline data-picker">
                  <VueCtkDateTimePicker
                    id="start"
                    v-model="estimated_start"
                    :right="true"
                    :no-label="false"
                    :no-value-to-custom-elem="true"
                    format="YYYY-MM-DD HH:mm"
                    formatted="llll"
                  >
                    <input
                      type="text"
                      id="startTime"
                      :value="estimated_start"
                      placeholder="When does this start"
                    />
                  </VueCtkDateTimePicker>
                </div>
              </div>
            </div>
            <div style="width: 70px"></div>
            <div class="flex-1">
              <div class="form-inline flex-row">
                <label for="">Project Length:</label>
                <div>
                  <input
                    type="text"
                    placeholder="Ex: 40 hours, 6 month, etc"
                    v-model="engagement"
                  />
                </div>
              </div>

              <div class="form-inline flex-row">
                <label for="">Work Type:</label>
                <div>
                  <model-select
                    :options="workTypeOptions"
                    v-model="work_type"
                  ></model-select>
                </div>
              </div>

              <div class="form-inline flex-row">
                <label for="">Company Name*:</label>
                <div>
                  <input
                    type="text"
                    placeholder="Name of the company"
                    v-model="company_name"
                  />
                </div>
              </div>
            </div>
          </div> -->
        </div>

        <div class="form2 flex p-t-l">
          <div class="flex-1 form-inline">
            <input type="text" placeholder="Your Email" v-model="email" />
          </div>
          <div class="flex-1 form-inline">
            <input
              type="text"
              placeholder="Company Name"
              v-model="company_name"
            />
          </div>
          <!-- <div class="tips" style="width: 450px">&nbsp;</div> -->
        </div>

        <div class="form-btn">
          <spinnerButton
            class="btn primary p-t-l p-b-l"
            @click.native="onSumbit"
            :loading="isLoading"
          >
            <i class="material-icons-outlined align-middle">logout</i>
            Submit Project
          </spinnerButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { addDoc } from "@/vendor/database";
import spinnerButton from "@/components/public/SpinnerButton";
import moment from "moment";
import { storagePut, storageGetDownloadUrl } from "@/vendor/firebase";
import { randomString } from "@/utils/utils";
import { httpGet } from "@/http/http";
import { ModelSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";

export default {
  name: "ProjectDefinition",
  components: {
    spinnerButton,
    VueCtkDateTimePicker,
    ModelSelect,
  },
  data() {
    return {
      editorOption: {
        modules: {
          toolbar: [
            ["link", "bold", "italic", { list: "ordered" }, { list: "bullet" }],
          ],
        },
        theme: "snow",
      },
      title: "",
      task: "",
      skills: "",
      rate_per_hour: "",
      engagement: "",
      location: "",
      work_type: "",
      estimated_start: "",
      company_name: "",
      email: "",
      isLoading: false,
      files: [],
      workTypeOptions: [
        { text: "remote", value: "remote" },
        { text: "onsite", value: "onsite" },
      ],
    };
  },
  methods: {
    onChange: async function (e) {
      this.files = (Object.entries(e.target.files) || [])
        .filter((item, index) => {
          if (index >= 5) return false;
          return item[1].size < 1024 * 1024 * 1000;
        })
        .map((item) => item[1]);
    },
    onSumbit: async function () {
      if (!this.title) {
        return this.$toasted.global.toast_error({
          message: "Please input title",
        });
      }
      if (!this.task) {
        return this.$toasted.global.toast_error({
          message: "Please input responsibilities",
        });
      }
      if (!this.skills) {
        return this.$toasted.global.toast_error({
          message: "Please input IT skill requirements",
        });
      }
      if (!this.company_name) {
        return this.$toasted.global.toast_error({
          message: "Please input company name",
        });
      }
      if (!this.email) {
        return this.$toasted.global.toast_error({
          message: "Please input email",
        });
      }
      const data = {
        title: this.title,
        task: this.task,
        company_name: this.company_name,
        email: this.email,
        roles: [
          {
            public: true,
            rate_to_client: this.rate_per_hour,
            work_type: this.work_type,
            engagement: this.engagement,
            location: this.location,
            id: randomString(10),
            requirements: this.skills,
            title: this.title,
            estimated_start:
              moment(this.estimated_start, "YYYY-MM-DD HH:mm").valueOf() / 1000,
          },
        ],
      };
      this.isLoading = true;
      const result = await httpGet("get_company_id", {
        company_name: this.company_name,
        email: this.email,
      });

      if (!result.ok || !result.data.company_id) {
        this.isLoading = false;
        this.$toasted.global.toast_error("error");
        return;
      }
      const files = [];
      if (this.files && this.files.length > 0) {
        for (const item of this.files) {
          const res = await storagePut(
            `projects_public/${this.company_name}/${this.title}/`,
            item.name,
            item
          );
          if (res.ok) {
            const res = await storageGetDownloadUrl(
              `projects_public/${this.company_name}/${this.title}/${item.name}`
            );
            if (res.ok) {
              files.push({
                name: item.name,
                url: res.data,
              });
            }
          }
        }
      }
      addDoc("gigs", {
        ...data,
        created: moment().valueOf() / 1000,
        phase: "Active searching",
        email_notification: true,
        public: "true",
        files,
        company: result.data.company_id,
        from: "definition",
        is_anon: true,
      })
        .then((res) => {
          if (res.ok) {
            httpGet("send_project_create_email", {
              id: res.data,
              email: this.email,
              company: result.data.company_id,
            });
            this.$toasted.global.toast_success("success");
            this.$router.push();
            this.$router.push({
              path: "project_detail_public/" + res.data + "/edit?first=true",
            });
          }
        })
        .catch(() => {
          this.$toasted.global.toast_error("error");
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style scoped>
.bg {
  background-image: url("/login_bg.png");
  background-size: cover;
  background-position: bottom;
}
.title {
  padding: 30px 20px 20px;
  margin: 0;
  font-size: 36px;
  font-weight: 600;
}
.form2 {
  width: 70%;
  max-width: 1200px;
  min-width: 900px;
  margin: 0 auto;
}
.form2 > div {
  margin-right: 0;
}
.form2 > div:not(:first-child) {
  margin-left: 24px;
}
.form {
  width: 70%;
  max-width: 1200px;
  min-width: 900px;
  margin: 90px auto 0;
  background: #ffffff;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1), 0px 2px 1px rgba(0, 0, 0, 0.06),
    0px 1px 1px rgba(0, 0, 0, 0.08);
  border-radius: 8px 8px 0px 0px;
}
.form-title {
  padding: var(--padding-l) var(--padding-l) var(--padding);
  font-size: 20px;
  font-weight: 900;
}
.section {
  padding: 0 var(--padding-l);
  padding-bottom: var(--padding-l);
  border-bottom: 1px solid #cacaca;
}
.form-inline {
  margin-left: 0;
  margin-right: 70px;
}
.form-inline input {
  font-size: 20px;
  height: 48px;
}
.section2 .form-inline {
  margin-right: 0;
}
.section2 .form-inline label {
  width: 150px;
  color: var(--font-color-light);
}
.section2 .form-inline input {
  font-size: 13px;
  height: 30px;
}
.tips {
  width: 430px;
  color: var(--font-color-light);
}
.tips p {
  margin: 0;
  padding: 0;
  font-size: 20px;
  line-height: 1.5;
}
.form-btn {
  width: 70%;
  max-width: 1200px;
  min-width: 900px;
  margin: var(--padding-l) auto;
  margin-bottom: 150px;
}
.form-btn .btn {
  font-size: 20px;
  padding-left: 80px;
  padding-right: 80px;
}
.form-btn i {
  margin-top: -5px;
  font-size: 20px;
}
.file-wrapper {
  position: relative;
  display: inline-block;
}
.file-input {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0;
  cursor: pointer;
}
.file-name-wrapper > div {
  margin-top: 4px;
}
</style>
